import React from 'react';
import { useTranslation } from 'react-i18next';

interface CloseButtonProps {
    onClick: () => void;
}

/**
 * The single dismiss control used by the modal header and the message/error alerts, so
 * they can't drift apart. Markup matches the close button in televeda-bootstrap's
 * `pages/login.html` modal header.
 *
 * Note `.btn-modal-close` positions itself with `margin-left: auto`, so its container
 * needs to be a flex row (rather than Bootstrap's absolutely-positioned `.btn-close`).
 */
const CloseButton = ({ onClick }: CloseButtonProps) => {
  const { t } = useTranslation();

  return (
    <button
      className='btn btn-subtle btn-modal-close'
      type='button'
      aria-label={t('CLOSE')}
      onClick={onClick}
    >
      <i aria-hidden='true' className='fa-jelly-duo fa-regular fa-xmark'></i>
    </button>
  );
};

export default CloseButton
